import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    backgroundColor: '#000000',
    borderRadius: 8,
    overflow: 'hidden',
  },
  playerWrapper: {
    position: 'relative',
    width: '100%',
    '& .video-js': {
      width: '100%',
      minHeight: 200,
      maxHeight: '70vh',
      backgroundColor: '#000000',
      borderRadius: 8,
      overflow: 'hidden',
      fontFamily: '"Nunito Sans", sans-serif',
      [theme.breakpoints.down('sm')]: {
        minHeight: 180,
        maxHeight: '60vh',
      },
    },
    // Custom Video.js theme - PGA Navy
    '& .video-js .vjs-big-play-button': {
      backgroundColor: 'rgba(0, 48, 135, 0.85)',
      border: 'none',
      borderRadius: '50%',
      width: 80,
      height: 80,
      lineHeight: '80px',
      fontSize: 40,
      marginTop: -40,
      marginLeft: -40,
      transition: 'transform 0.2s ease, background-color 0.2s ease',
      '&:hover': {
        backgroundColor: 'rgba(0, 35, 75, 0.95)',
        transform: 'scale(1.1)',
      },
      [theme.breakpoints.down('sm')]: {
        width: 64,
        height: 64,
        lineHeight: '64px',
        fontSize: 32,
        marginTop: -32,
        marginLeft: -32,
      },
    },
    '& .video-js .vjs-big-play-button .vjs-icon-placeholder:before': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    // Control bar styling
    '& .video-js .vjs-control-bar': {
      backgroundColor: 'rgba(0, 35, 75, 0.9)',
      height: 40,
      borderBottomLeftRadius: 8,
      borderBottomRightRadius: 8,
    },
    '& .video-js .vjs-play-progress': {
      backgroundColor: '#FFD700',
    },
    '& .video-js .vjs-load-progress': {
      backgroundColor: 'rgba(255, 255, 255, 0.3)',
    },
    '& .video-js .vjs-slider': {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
    },
    '& .video-js .vjs-volume-level': {
      backgroundColor: '#FFD700',
    },
    '& .video-js .vjs-time-control': {
      fontSize: 12,
      fontWeight: 600,
      lineHeight: '40px',
    },
    '& .video-js .vjs-button > .vjs-icon-placeholder:before': {
      fontSize: 20,
      lineHeight: '40px',
    },
    '& .video-js .vjs-control:focus': {
      textShadow: 'none',
    },
    '& .video-js .vjs-control:focus:before, .video-js .vjs-control:hover:before': {
      textShadow: '0 0 8px rgba(255, 215, 0, 0.8)',
    },
    // Progress bar hover tooltip
    '& .video-js .vjs-progress-control .vjs-mouse-display': {
      backgroundColor: '#FFD700',
    },
    '& .video-js .vjs-progress-control .vjs-time-tooltip': {
      backgroundColor: '#00234B',
      color: '#FFFFFF',
      fontSize: 11,
      fontWeight: 600,
      borderRadius: 4,
    },
    // Menu styling
    '& .video-js .vjs-menu-button-popup .vjs-menu': {
      backgroundColor: 'rgba(0, 35, 75, 0.95)',
      borderRadius: 4,
    },
    '& .video-js .vjs-menu li.vjs-menu-item': {
      fontSize: 12,
      padding: '8px 16px',
    },
    '& .video-js .vjs-menu li.vjs-selected, .video-js .vjs-menu li.vjs-menu-item:hover': {
      backgroundColor: 'rgba(255, 215, 0, 0.2)',
      color: '#FFD700',
    },
    // Fullscreen
    '& .video-js.vjs-fullscreen': {
      borderRadius: 0,
    },
    '& .video-js.vjs-fullscreen .vjs-control-bar': {
      borderRadius: 0,
    },
    // Loading spinner
    '& .video-js .vjs-loading-spinner': {
      borderColor: 'rgba(0, 48, 135, 0.8)',
    },
    '& .video-js .vjs-loading-spinner:before, .video-js .vjs-loading-spinner:after': {
      borderTopColor: '#FFD700',
    },
    // Poster
    '& .video-js .vjs-poster': {
      backgroundSize: 'cover',
    },
    // Error display
    '& .video-js .vjs-error-display': {
      backgroundColor: 'rgba(0, 35, 75, 0.9)',
    },
    '& .video-js .vjs-error-display:before': {
      color: '#FFD700',
    },
  },
}))

export default useStyles
